import { NoiseSuppressionModel } from '../model/types/classroom/enums'

export const NOISE_SUPPRESSION_MODEL: NoiseSuppressionModel = NoiseSuppressionModel.Rnnoise
export const NOISE_SUPPRESSION_SAMPLE_RATE = 48_000
export const NOISE_SUPPRESSION_CHANNELS = 1
export const NOISE_SUPPRESSION_PROCESSOR_NAME = 'noise-suppression'
